<script>
import { defineComponent, h } from 'vue';
import Facebook from './channels/Facebook.vue';
import Website from './channels/Website.vue';
import Twitter from './channels/Twitter.vue';
import Api from './channels/Api.vue';
import Email from './channels/Email.vue';
import Sms from './channels/Sms.vue';
import Whatsapp from './channels/Whatsapp.vue';
import Line from './channels/Line.vue';
import Telegram from './channels/Telegram.vue';
import Instagram from './channels/Instagram.vue';
import Tiktok from './channels/Tiktok.vue';
import Youtube from './channels/Youtube.vue';
import ZernioSocial from './channels/ZernioSocial.vue';
import Rcs from './channels/Rcs.vue';
import MercadoLivre from './channels/MercadoLivre.vue';
import Voice from './channels/Voice.vue';
import SocialNetwork from './channels/SocialNetwork.vue';

export default defineComponent({
  name: 'NewChannelView',
  props: {
    channelName: {
      type: String,
      required: true,
    },
  },
  render() {
    // Build the view map at render time to avoid TDZ issues from cyclic imports
    const channelViewList = {
      facebook: Facebook,
      website: Website,
      twitter: Twitter,
      api: Api,
      email: Email,
      sms: Sms,
      whatsapp: Whatsapp,
      line: Line,
      telegram: Telegram,
      instagram: Instagram,
      tiktok: Tiktok,
      youtube: Youtube,
      zernio_tiktok: ZernioSocial,
      zernio_linkedin: {
        render: () => h(ZernioSocial, { platform: 'linkedin' }),
      },
      zernio_google: {
        render: () => h(ZernioSocial, { platform: 'googlebusiness' }),
      },
      rcs: Rcs,
      mercado_livre: MercadoLivre,
      voice: Voice,
    };
    // Rede só de publicação: social_<rede> (cards de Novo canal, 08/10).
    if (this.channelName.startsWith('social_')) {
      return h(SocialNetwork, {
        key: this.channelName,
        platform: this.channelName.replace('social_', ''),
      });
    }
    const ChannelComponent = channelViewList[this.channelName];
    return ChannelComponent
      ? h(ChannelComponent, { key: this.channelName })
      : null;
  },
});
</script>
